import React from 'react'
import { NextPage, NextPageContext } from 'next'
import { SiteContentProvider } from 'contexts'
import { handingServerError, getHost } from 'fbk-utils'
import { HOME, NEWS_LIST } from 'constants/routes'
import * as api from 'api'
import Error from 'pages/_error'
import { Footer, Header, Meta } from 'components'
import { NewsArticle, NewsData } from 'types'
import Article from './Article'
import SharingSection from './SharingSection'
import OtherNews from './OtherNews'

type PageProps =
  | {
      host: string
      content: NewsArticle
      otherNews: NewsData
      error: null
    }
  | {
      error: {
        code: number
        message: string
      }
    }

const News: NextPage<PageProps> = props => {
  if (props.error) {
    return <Error error={props.error} />
  }

  const { content, otherNews, host } = props

  const goBackProps = {
    title: 'Все новости',
    ...NEWS_LIST,
  }

  return (
    <SiteContentProvider data={content} host={host}>
      <Meta />
      <Header
        title="Новость"
        breadcrumbs={[
          { title: 'Главная', ...HOME },
          { title: 'Все новости', ...NEWS_LIST },
        ]}
        goBackProps={goBackProps}
      />
      <Article content={content} goBackProps={goBackProps} />
      <SharingSection />
      <OtherNews data={otherNews} />
      <Footer />
    </SiteContentProvider>
  )
}

export const getServerSideProps = async (ctx: NextPageContext) => {
  try {
    const { id } = ctx.query

    if (typeof id !== 'string')
      return {
        props: {
          error: {
            code: 404,
            message: 'Такой страницы не существует',
          },
        },
      }

    const [content, otherNews] = await Promise.all([
      api.getNewsArticle(id),
      api.getNewsList({ exclude: id }),
    ])

    return {
      props: {
        host: getHost(ctx),
        content,
        otherNews,
        error: null,
      },
    }
  } catch (err) {
    const error = handingServerError(ctx, err)

    return {
      props: {
        error,
      },
    }
  }
}

export default News
